/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * Conference backend
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PresentationsurveyquestionOptions'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./PresentationsurveyquestionOptions'));
  } else {
    // Browser globals (root is window)
    if (!root.ConferenceBackend) {
      root.ConferenceBackend = {};
    }
    root.ConferenceBackend.Params3 = factory(root.ConferenceBackend.ApiClient, root.ConferenceBackend.PresentationsurveyquestionOptions);
  }
}(this, function(ApiClient, PresentationsurveyquestionOptions) {
  'use strict';




  /**
   * The Params3 model module.
   * @module model/Params3
   * @version 0.0.1
   */

  /**
   * Constructs a new <code>Params3</code>.
   * @alias module:model/Params3
   * @class
   */
  var exports = function() {
    var _this = this;





  };

  /**
   * Constructs a <code>Params3</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Params3} obj Optional instance to populate.
   * @return {module:model/Params3} The populated <code>Params3</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('presentationId')) {
        obj['presentationId'] = ApiClient.convertToType(data['presentationId'], 'String');
      }
      if (data.hasOwnProperty('_id')) {
        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('options')) {
        obj['options'] = ApiClient.convertToType(data['options'], [PresentationsurveyquestionOptions]);
      }
    }
    return obj;
  }

  /**
   * @member {String} presentationId
   */
  exports.prototype['presentationId'] = undefined;
  /**
   * @member {String} _id
   */
  exports.prototype['_id'] = undefined;
  /**
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * @member {Array.<module:model/PresentationsurveyquestionOptions>} options
   */
  exports.prototype['options'] = undefined;



  return exports;
}));






// WEBPACK FOOTER //
// ./generated/src/model/Params3.js